import { gql } from "@apollo/client";

export const UPDATE_REFERRAL_FORM = gql`
  mutation UpdateReferralForm(
    $formId: ID!
    $formFields: String
    $status: formStatus
  ) {
    updateForm(formId: $formId, formFields: $formFields, status: $status) {
      id
      url
      createdBy
      orgId
      formFields
      createdAt
      updatedAt
      status
      numberOfSubmissions
    }
  }
`;
